import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/category/')[1] || 'all';

  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-2 min-w-max px-4 md:px-6 py-2">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              currentSlug === cat.slug
                ? 'bg-primary-500 text-background-50 shadow-sm'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            <i className={`${cat.icon} text-sm`}></i>
            {cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
}